import { Button, View } from "@/components/ui";
import { ArrowLeft } from "@/components/shared/icons";
import { Link } from "@/components/shared/link";
import { InfoCard } from "@/components/shared/info-card";
import { Typography } from "@/components/shared/typography";
import { AddCreditCardForm } from "../add-credit-card-form";
import type { AddCreditCardScreenProps } from "..";
import { useInvoiceState } from "@/store/invoices";
import { cn } from "@/lib/utils";
import { IfElse } from "@/components/shared/if-else";
import { IconButton } from "@/components/ui/icon-button";
import { PaymentMethodScreenModal } from "@/types/invoice";

export const AddCreditCardScreen = ({
  loading,
  onConfirm,
  control,
  infoCardDesc,
}: AddCreditCardScreenProps) => {
  const {
    data: { addCreditCardScreenModal },
    showPaymentMethodModal,
  } = useInvoiceState();
  const handleClick = () => {
    showPaymentMethodModal(PaymentMethodScreenModal.SELECT_PAYMENT);
  };
  return (
    <>
      <View
        className={cn(
          addCreditCardScreenModal ? "p-0" : "p-4",
          "z-10 h-full flex-1 md:p-0",
        )}
      >
        <View className="mb-4 border-b pb-4 md:mb-8">
          <IfElse
            if={addCreditCardScreenModal}
            else={
              <View className="flex flex-row items-center gap-2 md:p-0">
                <Link href="/profile" className="md:hidden">
                  <ArrowLeft className="visible size-5" />
                </Link>
                <Typography variant="label-md">Add Your Credit Card</Typography>
              </View>
            }
          >
            <View className="flex flex-row items-center">
              <IconButton
                iconName="arrowLeft"
                color="foreground"
                onClick={handleClick}
                variant="tertiary"
              />
              <Typography variant="body-sm">Add Your Credit Card</Typography>
            </View>
          </IfElse>
        </View>

        <View className="mb-8 flex flex-col items-center gap-4">
          <AddCreditCardForm control={control} loading={loading} />
          <InfoCard description={infoCardDesc} />
        </View>

        <Button
          variant="primary"
          color="CTA"
          size="lg"
          onClick={onConfirm}
          loading={loading}
          className="md:ml-auto md:w-auto"
          children="Confirm"
        />
      </View>
    </>
  );
};
